(function () {
  function parseCount(text) {
    if (!text) return null;
    var match = String(text).match(/(\d[\d,]*)/);
    return match ? match[1].replace(/,/g, '') : null;
  }

  function formatScore(score) {
    var value = parseFloat(score);
    if (isNaN(value)) return null;
    return value.toFixed(1);
  }

  var STAR_PATH =
    'M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z';
  var STAR_FILLED_COLOR = '#000000';
  var STAR_EMPTY_COLOR = '#D9D9D9';

  /**
   * Star colours are baked into the SVG as fill/stroke attributes — and for a
   * partial star into <linearGradient> stops — so CSS can't recolour them
   * after the fact without destroying the half-star. Read them off the
   * wrapper instead, falling back to the constants above so every template
   * that doesn't set the properties renders exactly as before.
   */
  function getStarColors(wrapper) {
    var styles = window.getComputedStyle(wrapper);
    var filled = styles.getPropertyValue('--yotpo-star-filled').trim();
    var empty = styles.getPropertyValue('--yotpo-star-empty').trim();

    return {
      filled: filled || STAR_FILLED_COLOR,
      empty: empty || STAR_EMPTY_COLOR,
    };
  }

  function getWrapperUid(wrapper) {
    if (!wrapper.dataset.starUid) {
      wrapper.dataset.starUid =
        (wrapper.getAttribute('data-product-id') || '0') + '-' + Math.random().toString(36).slice(2, 9);
    }
    return wrapper.dataset.starUid;
  }

  function getStarFillPercents(score) {
    var value = parseFloat(score);
    if (isNaN(value)) {
      return [0, 0, 0, 0, 0];
    }

    value = Math.min(Math.max(value, 0), 5);
    var fills = [];

    for (var i = 0; i < 5; i++) {
      fills.push(Math.round(Math.min(Math.max(value - i, 0), 1) * 1000) / 10);
    }

    return fills;
  }

  function buildStarSvg(starIndex, fillPercent, uid, colors) {
    var gradientId = 'yotpo-pdp-star-' + uid + '-' + starIndex;
    var svgStart =
      '<svg class="product-yotpo-star-rating__star" width="14" height="14" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">';
    var pathAttrs = ' d="' + STAR_PATH + '" stroke="' + colors.filled + '"';

    if (fillPercent >= 100) {
      return svgStart + '<path' + pathAttrs + ' fill="' + colors.filled + '"/></svg>';
    }

    if (fillPercent <= 0) {
      return svgStart + '<path' + pathAttrs + ' fill="' + colors.empty + '"/></svg>';
    }

    return (
      svgStart +
      '<defs><linearGradient id="' +
      gradientId +
      '" x1="0%" y1="0%" x2="100%" y2="0%">' +
      '<stop offset="' +
      fillPercent +
      '%" stop-color="' +
      colors.filled +
      '"/>' +
      '<stop offset="' +
      fillPercent +
      '%" stop-color="' +
      colors.empty +
      '"/>' +
      '</linearGradient></defs>' +
      '<path' +
      pathAttrs +
      ' fill="url(#' +
      gradientId +
      ')"/></svg>'
    );
  }

  function buildStarsMarkup(score, uid, colors) {
    var fills = getStarFillPercents(score);
    var stars = '';

    for (var i = 0; i < 5; i++) {
      stars += buildStarSvg(i, fills[i], uid, colors);
    }

    return '<span class="product-yotpo-star-rating__stars" aria-hidden="true">' + stars + '</span>';
  }

  function extractFromDom(wrapper) {
    var score = null;
    var count = null;

    var scoreEl = wrapper.querySelector(
      '.yotpo-sr-bottom-line-score, .yotpo-bottom-line-score, .yotpo-bottom-line-left-panel.yotpo-bottom-line-score'
    );
    if (scoreEl) {
      score = formatScore(scoreEl.textContent);
    }

    var textEl = wrapper.querySelector('.yotpo-sr-bottom-line-text, .yotpo-bottom-line-text, .text-m');
    if (textEl) {
      count = parseCount(textEl.textContent);
    }

    if (!score) {
      var labeled = wrapper.querySelector('[aria-label*="star"], [aria-label*="rating"]');
      if (labeled) {
        var label = labeled.getAttribute('aria-label') || '';
        var scoreMatch = label.match(/([\d.]+)\s*(?:out of|stars?|rating)/i);
        if (scoreMatch) score = formatScore(scoreMatch[1]);
      }
    }

    if (!score || !count) {
      var pageScore = document.querySelector(
        '.yotpo-bottom-line-left-panel.yotpo-bottom-line-score, .yotpo-bottom-line-summary .yotpo-bottom-line-score'
      );
      var pageText = document.querySelector(
        '.yotpo-bottom-line-summary .yotpo-bottom-line-text, .yotpo-main-widget-layout .yotpo-bottom-line-text'
      );

      if (!score && pageScore) score = formatScore(pageScore.textContent);
      if (!count && pageText) count = parseCount(pageText.textContent);
    }

    return { score: score, count: count };
  }

  function fetchFromApi(appKey, productId) {
    if (!appKey || !productId) return Promise.resolve(null);

    return fetch(
      'https://api-cdn.yotpo.com/products/' + encodeURIComponent(appKey) + '/' + encodeURIComponent(productId) + '/bottomline'
    )
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data || !data.response || !data.response.bottomline || (data.status && data.status.code !== 200)) {
            return null;
          }

          var bottomline = data.response.bottomline;
          return {
            score: formatScore(bottomline.average_score),
            count: bottomline.total_reviews || bottomline.total_review
              ? String(bottomline.total_reviews || bottomline.total_review)
              : null
          };
        });
      })
      .catch(function () {
        return null;
      });
  }

  function buildCardMarkup(wrapper, data) {
    var reviewsLabel = wrapper.getAttribute('data-reviews-label') || 'reviews';
    var score = data.score;
    var count = data.count;

    if (!count) return '';

    var scoreMarkup = score
      ? '<span class="product-yotpo-star-rating__score">' + score + '</span>'
      : '';

    return (
      '<div class="product-yotpo-star-rating__inner product-yotpo-star-rating__inner--card">' +
        '<span class="product-yotpo-star-rating__star-icon" aria-hidden="true">★</span>' +
        scoreMarkup +
        '<span class="product-yotpo-star-rating__sep" aria-hidden="true">·</span>' +
        '<span class="product-yotpo-star-rating__count">' + count + ' ' + reviewsLabel + '</span>' +
      '</div>'
    );
  }

  function buildMarkup(wrapper, data) {
    var mode = wrapper.getAttribute('data-display-mode') || 'pdp';
    if (mode === 'card') {
      return buildCardMarkup(wrapper, data);
    }

    var suffix = wrapper.getAttribute('data-reviews-suffix') || 'on this style';
    var linkText = wrapper.getAttribute('data-link-text') || 'Read reviews ↓';
    var score = data.score;
    var count = data.count;

    if (!count) return '';

    var scoreMarkup = score
      ? '<span class="product-yotpo-star-rating__score">' + score + '</span>'
      : '';

    var starsMarkup = buildStarsMarkup(score, getWrapperUid(wrapper), getStarColors(wrapper));

    // 2026 PDP design: stars · score / count · link, no parenthesised suffix.
    if (wrapper.getAttribute('data-layout') === 'rebrand') {
      var reviewsWord = wrapper.getAttribute('data-reviews-label') || 'reviews';

      return (
        '<div class="product-yotpo-star-rating__inner">' +
          starsMarkup +
          scoreMarkup +
          '<span class="product-yotpo-star-rating__sep" aria-hidden="true">/</span>' +
          '<span class="product-yotpo-star-rating__count">' + count + ' ' + reviewsWord + '</span>' +
          '<a href="#product-reviews" class="product-yotpo-star-rating__link">' + linkText + '</a>' +
        '</div>'
      );
    }

    return (
      '<div class="product-yotpo-star-rating__inner">' +
        starsMarkup +
        scoreMarkup +
        '<span class="product-yotpo-star-rating__count">(' + count + ' ' + suffix + ')</span>' +
        '<span class="product-yotpo-star-rating__sep" aria-hidden="true">·</span>' +
        '<a href="#product-reviews" class="product-yotpo-star-rating__link">' + linkText + '</a>' +
      '</div>'
    );
  }

  function getReviewsTarget() {
    var target =
      document.getElementById('product-reviews') ||
      document.querySelector('[data-yotpo-reviews-hub]') ||
      document.querySelector('#yotpo-reviews-main-widget') ||
      document.querySelector('.yotpo-main-widget-layout') ||
      document.querySelector('.yotpo-widget-instance[data-yotpo-product-id]');

    if (target && !target.id) {
      target.id = 'product-reviews';
    }

    return target;
  }

  function bindScrollLink(wrapper) {
    var link = wrapper.querySelector('.product-yotpo-star-rating__link');
    if (!link || link.dataset.bound === 'true') return;
    link.dataset.bound = 'true';

    link.addEventListener('click', function (event) {
      event.preventDefault();

      var target = getReviewsTarget();
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function finalizeEmptyCardWrapper(wrapper) {
    if (wrapper.getAttribute('data-display-mode') !== 'card') return;

    wrapper.classList.add('is-ready', 'is-empty');
    wrapper.removeAttribute('aria-label');
  }

  function renderWrapper(wrapper, data) {
    if (!data || !data.count) return false;

    var display = wrapper.querySelector('.product-yotpo-star-rating__display');
    if (!display) return false;

    var markup = buildMarkup(wrapper, data);
    if (!markup) return false;

    display.innerHTML = markup;
    wrapper.classList.add('is-ready');
    wrapper.classList.remove('is-empty');
    wrapper.setAttribute(
      'aria-label',
      (data.score ? data.score + ' out of 5 stars. ' : '') + data.count + ' reviews'
    );
    bindScrollLink(wrapper);
    return true;
  }

  function hydrateWrapper(wrapper) {
    if (wrapper.classList.contains('is-ready')) return true;

    var domData = extractFromDom(wrapper);
    if (domData.count) {
      return renderWrapper(wrapper, domData);
    }

    return false;
  }

  function hydrateWithApi(wrapper) {
    if (wrapper.classList.contains('is-ready')) return;

    var appKey = wrapper.getAttribute('data-yotpo-app-key');
    var productId = wrapper.getAttribute('data-product-id');

    fetchFromApi(appKey, productId).then(function (apiData) {
      if (apiData && apiData.count) {
        renderWrapper(wrapper, apiData);
      } else {
        finalizeEmptyCardWrapper(wrapper);
      }
    });
  }

  function initWrapper(wrapper) {
    if (wrapper.classList.contains('is-ready')) return;

    if (hydrateWrapper(wrapper)) return;

    hydrateWithApi(wrapper);

    var source = wrapper.querySelector('.product-yotpo-rating-source');
    if (!source) return;

    var observer = new MutationObserver(function () {
      if (hydrateWrapper(wrapper)) {
        observer.disconnect();
      }
    });

    observer.observe(source, { childList: true, subtree: true, characterData: true });

    window.setTimeout(function () {
      observer.disconnect();
    }, 8000);
  }

  function initAll() {
    document.querySelectorAll('[data-yotpo-star-rating]').forEach(initWrapper);
  }

  window.initYotpoStarRatings = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
